import React from "react";
import NewButton from "../NewButton/NewButton";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import styles from "./ProductCard.module.css";

export default function ProductCard({ title, description, image, imageAlt = "product", buttonText = "Watch Video", videoUrl, onWatchClick }) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.cardTitle}>{title}</h2>
        <p className={styles.cardDescription}>{description}</p>
      </div>
      <div className={styles.imageSection}>
        <img src={image} loading="lazy" alt={imageAlt} className={styles.productImage} />
      </div>
      <NewButton className={styles.cardButton} rightSection={<IconArrowNarrowRight strokeWidth={3} size={30} />} onClick={onWatchClick}>
        {buttonText}
      </NewButton>
    </div>
  );
}
